import { render, staticRenderFns } from "./junk-charts.vue?vue&type=template&id=5ae0b3d7&scoped=true&"
import script from "./junk-charts.vue?vue&type=script&lang=js&"
export * from "./junk-charts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae0b3d7",
  null
  
)

export default component.exports